import { ApiError, fetchWithAuth } from "@entities/user-tokens";

/** 確認済みの記録。無ければサーバーは空の器を返す（404 にしない）。 */
export type TaskReviewedMarks = {
    updatedAt: string;
    updatedBy: string;
    items: { [key: string]: { by: string; at: string } };
};

/**
 * 確認済みを読む。
 *
 * **Web コンソールと同じ器を共有する。** 記録の単位は枠なので、Web で付けたチェックがここでも
 * 見え、その逆も成り立つ。同じ成果物を 2 つの画面で確かめるので、記録が分かれていると数が
 * 合わなくなる（[[2026-09-10 設計ノート アドイン 生成結果画面の結果情報対応]]）。
 */
export async function getTaskReviewed(
    projectId: string,
    taskId: string
): Promise<TaskReviewedMarks> {
    const res = await fetchWithAuth(
        `/generation-tasks/${encodeURIComponent(taskId)}/reviewed` +
            `?projectId=${encodeURIComponent(projectId)}`,
        { headers: { Accept: "application/json" } }
    );
    if (!res.ok) throw await ApiError.fromResponse(res, "確認済みの記録を取得できませんでした");
    const body = (await res.json()) as { reviewed: TaskReviewedMarks };
    return body.reviewed;
}
